import { request } from "../../platform/apiClient/apiRequest";
import type { MasryAnswer } from "../types/masry.types";

export const masryClient = {
  ask: (question: string) => request<MasryAnswer>("/policies/ask", { method: "POST", body: JSON.stringify({ question }) }),
};
